import send from './util/request';
// 退货单列表
export const commonCurrency = (params = {}) => {
	return send({ url: '/ipp/common/currency', method: 'POST', data: params, options: { loading: true } });
};

// PV统计接口
export const apiLog = (params = {}) => {
	return send({ url: '/api/log', method: 'POST', data: params });
};

// 用户关联公司列表
export const userJoinCompanys = (params = {}) => {
	return send({ url: '/ipp/v3/user/join-companys', method: 'POST', data: params });
};

// 切换当前公司
export const userSwitchCompanys = (params = {}) => {
	return send({ url: '/ipp/v3/user/switch-companys', method: 'POST', data: params });
};